import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FixedBody from '../../../../Common/FixedBody';
import Permission from '../../../../../classes/common/permission';
import { truncText } from '../../../../../utils/formater';
import { getUrlWithSize } from '../../../../../utils/urls';

class Description extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showFullInfoModal: false
    };

    this.item = this.props.item;
    this.deal = this.item.getDeal();
    this.handlerOpenDescriptionModal = this.handlerOpenDescriptionModal.bind(this);
    this.handlerCloseDescriptionModal = this.handlerCloseDescriptionModal.bind(this);
  }

  componentWillReceiveProps (nextProps, nextContext) {
    this.item = nextProps.item;
  }

  handlerOpenDescriptionModal (e) {
    const isAdmin = this.props.user.getIn(['data', 'isAdmin'], false) || false;
    if (isAdmin) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      showFullInfoModal: isAdmin
    });
  }

  handlerCloseDescriptionModal () {
    this.setState({
      showFullInfoModal: false
    });
  }

  renderModal () {
    const property = this.item.getProperty();
    const geoLocation = property.getGeoLocation();
    const permission = this.item.getPermissions();

    return (
      <Modal
        isOpen={this.state.showFullInfoModal}
        onRequestClose={this.handlerCloseDescriptionModal}
        portalClassName='description-modal'
        className='description-modal__content'
        overlayClassName='description-modal__overlay'
      >
        <FixedBody />
        <div className='link-object'>
          <a target='_blank' className='location' href={this.item.getLink()}>
            {geoLocation.getShortAddress()}
          </a>

          {
            permission.isAllow(Permission.IS_EDIT) &&
            (
              <a
                href={this.item.getEditLink()}
                target='_blank'
              >редактировать</a>
            )
          }
        </div>
        <div className='description'>
          {this.item.getDescription()}
        </div>
        <div className='photo-gallery-scroll'>
          <div className='photo-gallery'>
            {
              this.item.getPhotos()
                .map((photo, index) => {
                  return (
                    <img key={index} src={getUrlWithSize(photo.get('url'), '320x240')} />
                  );
                })
            }
          </div>
        </div>
      </Modal>
    );
  }

  render () {
    if (this.item.getDeal()) {
      return null
    }

    return (
      <div className='property__description'>
        <div onClick={this.handlerOpenDescriptionModal}>{ truncText(this.item.getDescription(), 115) }</div>
        { this.renderModal() }
      </div>
    );
  }
}

Description.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

Description.defaultProps = {
};

export default Description;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/Items/Description.jsx